<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Placement Team</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li>
              Placement
            </li>/
            <li class="text-white">
              Placement Team
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center row-cols-2 gx-4">
      <div class="col-md-3">
        <div class="faculty-div bg-white shadow">
          <div class="faculty-img">
            <img src="{{baseUrl}}/faculty/prf.pranali-sisodiya.webp" class="img-fluid w-100"
              alt="Prf.Pranali Sisodiya | GHRCACS,Pune">
          </div>
          <div class="faculty-details text-center my-2 pt-3">
            <h4 class="primary-purple fw-bold">Prf.Pranali Sisodiya</h4>
            <h6>(Dean III and Training & Placement Officer)</h6>
            <br>
          </div>
        </div>
      </div>
       <div class="col-md-3">
        <div class="faculty-div bg-white shadow">
          <div class="faculty-img">
            <img src="{{baseUrl}}/faculty/prf.sonika-kamathe.webp" class="img-fluid w-100"
              alt="Prf.Sonika Kamathe | GHRCACS,Pune">
          </div>
          <div class="faculty-details text-center my-2 pt-3">
            <h4 class="primary-purple fw-bold">Prf.Sonika Kamathe</h4>
            <h6>(Dy.Dean III)</h6>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
